<template>
  <div>
    <div class="modal fade" id="modalBaixa" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
    	<div class="modal-dialog modal-lg">
    		<div class="modal-content">
    			<div class="modal-header">
    				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
    					<span aria-hidden="true">&times;</span>
    				</button>
    				<h4 class="modal-title">Baixar Movimento Financeiro</h4>
    			</div>
    			<div class="modal-body">
    				<div class="row">
    					<div class="col-sm-6 col-md-6">
    						<div class="row">
    							<div class="col-sm-1 col-md-1">
    								<label class="label-filtros">C�d.</label>
                    <input id="baixarId" class="form-control" />
    							</div>
    							<div class="col-sm-11 col-md-11">
    								<label class="label-filtros">Titular</label> <input
    									id="baixarTitular" class="form-control" />
    							</div>
    						</div>
    						<div class="row">
    							<div class="col-sm-3 col-md-3">
    								<label class="label-filtros">Vencimento:</label>
                    <input-data-picker id="baixarVencimento" class="form-control pula data" />
    							</div>
    							<div class="col-sm-3 col-md-3">
    								<label class="label-filtros">Valor:</label> <input
    									id="baixarValor" class="form-control pula monetario" />
    							</div>

    							<div class="col-sm-3 col-md-3">
    								<label class="label-filtros">Multa:</label> <input
    									id="baixarMulta" class="form-control pula monetario" />
    							</div>
    							<div class="col-sm-3 col-md-3">
    								<label class="label-filtros">Juros:</label> <input
    									id="baixarJuros" class="form-control pula monetario" />
    							</div>
    						</div>
    						<div class="row">
    							<div class="col-sm-3 col-md-3">
    								<label class="label-filtros">Data Pagamento:</label> <input
    									id="baixarDataPagamento" class="form-control pula data" />
    							</div>
    							<div class="col-sm-3 col-md-3">
    								<label class="label-filtros">Valor Pago:</label> <input
    									id="baixarValorPago" class="form-control pula monetario" />
    							</div>
    						</div>
    						<br>
    						<br>
    						<div class="row">
    							<div class="col-md-4">
    								<label class="label-filtros">Usar Credito?</label>
    								<select id="baixarUsarCreditoTitular" class="form-control custom">
    									<option value="nao">N�o</option>
    	  								<option value="sim">Sim</option>
    								</select>
    							</div>
    							<div class="col-md-4">
    								<label class="label-filtros">Credito Disponivel:</label>
    								<input id="baixarCreditoTitularDisponivel" class="form-control pula monetario" />
    							</div>
    							<div class="col-md-4">
    								<label class="label-filtros">Credito Utilizado:</label>
    								<input id="baixarCreditoTitularUtilizado" class="form-control pula monetario" />
    							</div>
    						</div>
    						<div class="row">
    							<div class="col-md-12">
    								<label class="label-filtros">Lan�ar diferen�a de pagamento como:</label>
    								<select id="baixarDiferencaPagamento" class="form-control custom">
    									<option value="desconto">Desconto</option>
    	  								<option value="parcela">Parcela</option>
    	  								<option value="credito">Cr�dito</option>
    								</select>
    							</div>
    						</div>
    						<div class="row">
    							<div class="col-md-6">
    								<label id="labelBaixarValorDesconto" class="label-filtros">Desconto:</label>
    								<input id="baixarValorDesconto" class="form-control pula monetario"/>
    							</div>
    							<div class="col-sm-6 col-md-6">
    								<label class="label-filtros">Novo Vencimento:</label>
    								<input id="baixarNovaDataVencimento" class="form-control pula data" />
    							</div>

    						</div>

    					</div>

    					<div class="col-sm-6 col-md-6">
    						Efetuar baixa utilizando:
    						<select id="baixarTipoPagamento" class="form-control custom">
    							<option value="dinheiro">Dinherio</option>
    							<option value="cheque">Cheque</option>
    						</select>
    						<div class="row">
    							<div class="col-sm-12 col-md-12">
    								<label id="labelAdicionarCheque">Pagamento com Cheques</label>
    							</div>
    							<div class="col-sm-4 col-md-4">
    							</div>
    							<div class="col-sm-4 col-md-4">
    								<button id="utilizarCheque" type="button" class="btn btn-primary pull-right">Utilizar Cheque</button>
    							</div>
    							<div class="col-sm-4 col-md-4">
    								<button id="adicionarCheque" type="button" class="btn btn-primary pull-right">Adicionar Cheque</button>
    							</div>
    						</div>

    						<table id="tabelaCheques" width="100%">
    						</table>
    					</div>
    				</div>
    			</div>
    			<div class="modal-footer">
    				<button id="gravarBaixa" type="button" class="btn btn-primary">Gravar Pagamento</button>
    				<button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
    			</div>
    		</div>
    		<!-- /.modal-content -->
    	</div>
    	<!-- /.modal-dialog -->
    </div>
    <input class="btn"/>
  </div>
</template>

<script>
  let vm = {
    name: 'botao-baixa-financeiro',
    props: {
      speed: {
        default: 20
      }
    }
  }
  module.exports = vm
</script>



// WEBPACK FOOTER //
// src/components/spark-components/spark-scrollbar/SparkBotaoBaixaFinanceiro.vue